import React from 'react';
import { Typography } from '@mui/material';
import IntlMessages from 'lngProvider/IntlMessages';

const PasswordHelperText = ({ data }) => {
    var newPasswordHas8Chars = false;
    var newPasswordHasLower = false;
    var newPasswordHasUpper = false;
    var newPasswordHasNumbers = false;
    var newPasswordHasSpecialChars = false;

    const meetsLengthRequirement = (password) => {
        newPasswordHas8Chars = password && password.length >= 8;
        return newPasswordHas8Chars;
    }

    const containsLower = (password) => {
        newPasswordHasLower = password && password.match(/(?=.*?[a-z])/) !== null;
        return newPasswordHasLower;
    }

    const containsUpper = (password) => {
        newPasswordHasUpper = password && password.match(/(?=.*?[A-Z])/) !== null;
        return newPasswordHasUpper;
    }

    const containsCorrectCase = (password) => {
        return containsLower(password) && containsUpper(password);
    }

    const containsNumbers = (password) => {
        newPasswordHasNumbers = password && password.match(/(?=.*\d)/) !== null;
        return newPasswordHasNumbers;
    }

    const containsSpecialCharacters = (password) => {
        newPasswordHasSpecialChars = password && password.match(/(?=.*[^A-Za-z0-9])/) !== null;
        return newPasswordHasSpecialChars;
    }

    const passwordInvalid = () => {
        if (data.newPassword && data.newPassword !== '' &&
        (!meetsLengthRequirement(data.newPassword) ||
            !containsCorrectCase(data.newPassword) ||
            !containsNumbers(data.newPassword) ||
            !containsSpecialCharacters(data.newPassword))) {
            return true;
        }

        return false;
    }

    return (
        <React.Fragment>
            {passwordInvalid() === true ?
                <Typography variant="caption" color="error"><IntlMessages id="changePassword.shortValidation" /></Typography>
            :
                data.newPassword && data.newPassword !== "" ?
                    <Typography variant="caption"><IntlMessages id="changePassword.passwordValidationSuccess" /></Typography>
                : "" 
            }
        </React.Fragment>
    );
}

export default PasswordHelperText;